import { ChangeDetectionStrategy, Component, DoCheck, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { NPageOffCanvas, PageOffCanvasComponent } from '../page-off-canvas.component';

@Component({
    selector: 'page-off-canvas-menu',
    templateUrl: 'page-off-canvas-menu.html',
    styleUrls: ['page-off-canvas-menu.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageOffCanvasMenuComponent extends UiComponent implements NICmsContentComponent.IComponent, DoCheck, OnInit {
    @ICmsContent({
        watchDepth: 1
    })
    @Input()
    component?: NPageOffCanvas.IMenuComponentData & NPageOffCanvas.IMenuItem;
    /**
     * I failed with subcomponents
     */
    protected override canDetach = false;

    /**
     * Access to enum
     */
    readonly EMenuItemType = NPageOffCanvas.EMenuItemType;

    @ViewChild('scrollable', { read: ElementRef })
    public scrollable?: ElementRef<HTMLElement>;

    /**
     * Parent menu (for submenus)
     */
    @Input()
    parent?: NPageOffCanvas.IMenu;

    /**
     * Parent menu (for submenus)
     */
    @Input()
    parentId: string = '0';

    /**
     * Depth level
     */
    @Input()
    level = 0;

    constructor(
        readonly toggleService: ToggleService,
        private cmsPageOffCanvasMenuComponent: PageOffCanvasComponent,
        private roter: Router
    ) {
        super();
    }

    /**
     * Getter for only menus with children
     */
    get menusWithChildren() {
        return (
            this.component?.menu?.map((menu, index) => ({ ...menu, index })).filter(i => i.type === NPageOffCanvas.EMenuItemType.menu) || []
        );
    }

    override ngOnInit(): void {
        super.ngOnInit();
        // scroll back to top when opening off canvas (all menus)
        this.subscriptions.add(
            this.cmsPageOffCanvasMenuComponent.offCanvasState.subscribe(open => {
                if (open && this.scrollable) {
                    this.scrollable.nativeElement.scrollTop = 0;
                }
            })
        );
        // scroll back to top when reopening this very menu (submenues)
        if (this.level >= 0) {
            this.subscriptions.add(
                this.cmsPageOffCanvasMenuComponent.level.subscribe(level => {
                    if (level === this.level && this.scrollable) {
                        this.scrollable.nativeElement.scrollTop = 0;
                    }
                    this.detectChanges();
                })
            );
        }
    }

    /**
     * sanitize
     */
    ngDoCheck() {
        this.menusWithChildren.filter(i => !i.subItem).forEach(i => (i.subItem = { menu: [] }));
    }

    /**
     * Opens submenu
     */
    menuClick(menu: NPageOffCanvas.IMenuItem, index) {
        if (menu.type === NPageOffCanvas.EMenuItemType.menu) {
            this.toggleService.open([this.parentId, index]);
            this.cmsPageOffCanvasMenuComponent.changeMenuTitle(menu.text, this.level + 1);
            this.cmsPageOffCanvasMenuComponent.setLevel(this.level + 1);
        } else if (menu.link) {
            this.roter.navigateByUrl(menu.link);
        }
    }

    getItemData(item: NPageOffCanvas.IMenuComponentData): NICmsContentComponent.IData {
        return Object.assign({}, item, { id: NPageOffCanvas.MENU_COMPONENT_ID });
    }

    // need for remove scroll when per level is bigger
    protected isNotVisible() {
        return this.level !== this.cmsPageOffCanvasMenuComponent.level.value;
    }

    /**
     * Force the type (hack to use compoent in cms)
     */
    protected onComponentChange(): void {
        if (this.component) {
            this.component.id = NPageOffCanvas.MENU_COMPONENT_ID;
        }
    }
}
